
























































import {Component, Vue, Prop, Watch} from 'vue-property-decorator'
import InterviewQuestionComponent from '@/components/InterviewQuestion.vue'
import {projectStore} from '@/store'
import {InterviewQuestion, InterviewQuestions} from '@/models'
import {Interview as InterviewAnswers} from '@/store/interview'
import {load} from 'js-yaml'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

@Component({
  components: {
    InterviewQuestionComponent, VuePerfectScrollbar,
  }
})
export default class Interview extends Vue {
  @Prop({default: '50vw'}) readonly width!: string

  phase = 0
  questions: InterviewQuestions | null = null

  get topicNames() { // return array of topic names
    if (!this.questions) return []
    return Object.keys(this.questions).filter(x => x !== '_DEFAULT')
  }
  get interview(): InterviewAnswers | null {
    return projectStore.project ? projectStore.project.interview : null
  }

  nextTopic(idx: number) {
    const nTopics = this.topicNames.length
    if (idx + 1 >= nTopics) return 0
    return idx + 1
  }
  prevTopic(idx: number) {
    const nTopics = this.topicNames.length
    if (idx - 1 < 0) return nTopics - 1
    return idx - 1
  }
  save() {
    this.$toast('Saved!')
  }

  /** Interview-question answer, from vuex */
  questionAnswer(topic: string, question: string) {
    if (!projectStore.project) return null
    return projectStore.project.interview.questionAnswers[question]
  }

  /** Store the answer to the question
   * Used as the change event from the question component
   */
  async answerQuestion(args: {question: InterviewQuestion; answer: string}) {
    await projectStore.answerQuestion({
      questionId: args.question.name,
      answer: args.answer
    })
  }

  // @Watch('interview', {deep: true})
  // onInterviewChanged(val: InterviewAnswers, oldVal: InterviewAnswers) {
  //   Vue.$log.info('Interview data changed: new val = ', val)
  // }

  async mounted() {
    // Note: this is async, but Vue doesn't await on it.
    // So this will return before the questions are actually live.
    Vue.$log.debug(`Loading questions...`)
    const url = '/interview-questions.yaml' // files in /public/foo are served as /foo
    const response = await fetch(url)
    if (response.ok) {
      try {
        const data = await response.text()
        const q = load(data)
        this.questions = q
      } catch (err) {
        this.$error(`Can't parse questions from ${url}`, err)
      }
    } else {
      this.$toast.error(`Couldn't retrieve questions from ${url}: ${response.status}: ${response.statusText}`)
    }
  }
}
